import React from "react";

const JobSeekers = () => {
    return <div>JobSeekers</div>;
};

export default JobSeekers;
